import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import edit from "icons/solid/pencil.svg";
import UserBookType from "types/UserBookType";

export default function EditReviewButton({
  userId,
  slug,
  className
}: {
  userId: UserBookType["userId"];
  slug?: string,
  className?: string,
}) {
  const currentUserId = useCurrentUserId();

  return (
    userId === currentUserId && !!slug && 
    <Button
      variant="ghost"
      size="sm"
      as={{
        element: "link",
        props: {
          href: `/books/${slug}/reviews/edit`,
          "aria-label": "Edit review",
        }
      }}
      className={className}
    >
      <Icon icon={edit} size="md" aria-label="Edit Icon" />
    </Button>
    
  );
}
